export const sitesConstants = {
  SET_SITES_SUCCESS: 'SET_SITES_SUCCESS',
  SET_SITES_FAILURE: 'SET_SITES_FAILURE',

  ADD_SITE_SUCCESS: 'ADD_SITE_SUCCESS',
  ADD_SITE_FAILURE: 'ADD_SITE_FAILURE',

  EDIT_SITE_SUCCESS: 'EDIT_SITE_SUCCESS',
  EDIT_SITE_FAILURE: 'EDIT_SITE_FAILURE',

  REMOVE_SITE_SUCCESS: 'REMOVE_SITE_SUCCESS',
  REMOVE_SITE_FAILURE: 'REMOVE_SITE_FAILURE',
};
